import React from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga'; 
import 'bootstrap/dist/css/bootstrap.min.css'; 
import './index.css';
import './App.css';
import './components/Home.css';
import './components/OurNetworks.css';
import './components/OurTeam.css';
import './components/WhatOffer.css';
import './components/ContactUs.css';
import './components/ServiceInternalPage.css';
import './components/ChooseUsCard.css';
import './components/Services.css';
import './components/Navbar.css';
import './components/CopyRight.css';
import './components/Blog.css';
import './components/HowWorks.css';
import './components/ChooseUs.css';
import './components/ContactForm.css';
import './components/IndustriesWeServe.css';
import './components/RelatedServices.css';
import './components/OurTeamCard.css';
import './components/TestimonialCarousel.css';
import './components/OurMission.css';
import './components/HowWorksCards.css';
import './components/HowWorksCards2.css';
import './components/ServicesSection.css';
import './components/Header.css';
import './components/FaqComponent.css';
import './components/CustomButton.css';
import './components/PortfolioSection.css';
import './components/Cards.css';
import './components/BlogCards.css';
import './components/WhoWeAre.css';
import './components/StudyCase.css';
import './components/LoveWeb5.css';
import './components/Loader.css';
import './components/WhoWeAre2.css';
import './components/TechStack.css';
import './components/AboutUs.css';
import './components/LatestBlogs.css';
import './components/BlogSideCard.css';
import './components/Footer.css';
import './components/ContactUsForm2.css';
import './components/BlogSection.css';
import './components/PortfolioCards.css';
import './components/EmailSubscription.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const startAnalytics = () => {
  ReactGA.initialize('G-PYTC67RM86');
  ReactGA.pageview(window.location.pathname + window.location.search);
};

if (document.readyState === 'complete') {
  startAnalytics();
} else {
  window.addEventListener('load', startAnalytics, { once: true });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

    <App />
 
);

reportWebVitals();
